import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectControls } from '../../redux/controls';
import { selectPrevLoaded, selectPrevLoading, selectTabLoaded, selectTabLoading } from '../../redux/queryResults';
import { selectSwitchViewSelected } from '../../redux/switchView';
import { LIST_VIEW, QUESTION_VIEW } from '../../redux/switchView/models';
import ListView from '../ListView/ListView';
import QuestionView from '../QuestionView/QuestionView';
import Spinner from '../Spinner/Spinner';
import { loadedStyle, loadingStyle, QueryResultsProps } from './models';

import './QueryResults.scss';

export function QueryResults({tabData, setTabData, showFullTable}: QueryResultsProps):JSX.Element {
  const controls = useSelector(selectControls);
  const selectedSwitchView = useSelector(selectSwitchViewSelected);
  const tabLoading = useSelector(selectTabLoading);
  const tabLoaded = useSelector(selectTabLoaded);
  const prevLoading = useSelector(selectPrevLoading);
  const prevLoaded = useSelector(selectPrevLoaded);

  // Tracks if selectedSwitchView window has loaded content
  const [isLoaded, setIsLoaded] = useState(false);
  // Sets Spinner
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (selectedSwitchView === LIST_VIEW) {
      setIsLoaded(!!tabLoaded);
    } else if (selectedSwitchView === QUESTION_VIEW) {
      setIsLoaded(!!prevLoaded);
    }
  },[selectedSwitchView, tabLoaded, prevLoaded]);

  useEffect(() => {
    if (selectedSwitchView === LIST_VIEW) {
      setIsLoading(!!tabLoading);
    } else if (selectedSwitchView === QUESTION_VIEW) {
      setIsLoading(!!prevLoading);
    }
  },[selectedSwitchView, tabLoading, prevLoading]);

  return (
    <div className="nqt-qr" style={isLoaded ? loadedStyle : loadingStyle}>
      { isLoading && <Spinner/> }
      {
        isLoaded ?
          (
            <>
              <ListView hidden={selectedSwitchView !== LIST_VIEW} tabData={tabData} setTabData={setTabData} showFullTable={showFullTable} />
              <QuestionView hidden={selectedSwitchView === LIST_VIEW} />
            </>
          ) :
          <p>{controls?.Preview?.controlText}</p>
      }
    </div>
  );
}

export default QueryResults;